import { ScreenSize, useIsScreenSize } from '@treatwell/treatwell-aura';
import { css } from '@emotion/react';
import { JSXElementConstructor } from 'react';

export type ElementWrapperTemplate = {
  display: boolean;
  ElementComponent: JSXElementConstructor<object>;
};

export function ElementWrapperTemplate(
  props: ElementWrapperTemplate,
): JSX.Element {
  const { display, ElementComponent } = props;
  const isSMAndUnder = useIsScreenSize(ScreenSize.SMAndUnder);

  return (
    <div
      css={css({
        display: display ? 'flex' : 'none',
        maxWidth: 800,
        padding: isSMAndUnder ? 24 : 80,
        // size of footer
        margin: 'auto',
        marginBottom: 100,
      })}
    >
      <ElementComponent />
    </div>
  );
}
